import Trabalho from "@/Models/Sistema/Trabalho";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";
import { useConciliacaoAuttarDesativar } from "@/Services/Financeiro/Conta/ConciliacaoAuttarService";
import { Button, ButtonProps, Popconfirm, PopconfirmProps } from "antd";
import { RenderFunction } from "antd/lib/_util/getRenderPropValue";
import { AxiosResponse } from "axios";
import { ReactNode } from "react";

export interface IConciliacaoAuttarDesativarPopconfirmProps extends Omit<PopconfirmProps, "title" | "description"> {
    trabalho:Trabalho;
    onSuccess?:(response:AxiosResponse<void, any>, input:Trabalho) => void;
    title?:ReactNode | RenderFunction;
    description?:ReactNode | RenderFunction;
    openButtonProps?:ButtonProps;
    codTrabalhoTipo:EnumTrabalhoTipo;
}

export default function ConciliacaoAuttarDesativarPopconfirm({
    trabalho,
    onSuccess,
    title,
    openButtonProps,
    description,
    destroyTooltipOnHide,
    codTrabalhoTipo,
    children,
    ...props
}:IConciliacaoAuttarDesativarPopconfirmProps) {
    title = title === undefined ? "Desativar" : title;
    description = description === undefined ? "Tem certeza de que deseja desativar a conciliação?" : description;
    destroyTooltipOnHide = destroyTooltipOnHide ?? true;

    const {
        isPending,
        mutate
    } = useConciliacaoAuttarDesativar({
        codTrabalhoTipo,
        onSuccess(data, variables, context) {
            onSuccess?.(data, variables);
        },
    });

    return <Popconfirm
        {...props}
        title={title}
        // description={description}
        destroyTooltipOnHide={destroyTooltipOnHide}
        onConfirm={() => mutate(trabalho)}
        okButtonProps={{
            loading : isPending
        }}
    >
        {
            !!children || <Button
                {...openButtonProps}
                type={openButtonProps?.type ?? 'primary'}
                size={openButtonProps?.size ?? 'small'}
                danger={openButtonProps?.danger ?? true}
                style={{ 
                    ...openButtonProps?.style,
                    width : openButtonProps?.style?.width ?? "min-content" 
                }}
            >
                Desativar
            </Button>
        }
    </Popconfirm>;
}